import { RFIOrganizations } from '../../../cimsPage/instances/rfi'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const object = 'Organization'
const page = RFIOrganizations

const rfiOrganization = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: '5b392fe2-032e-4173-a7fb-bc151a424945',
  view: 'b8acf451-dadd-44b6-a679-c27002e07efa',
  edit: '9983c2bd-242e-4539-a92c-a94cad4e16d8',
  removeRestore: '3a3176d4-6d01-4d90-8d50-19346911b1ab',
})

export const CreateRFIOrganization = rfiOrganization.Create
export const ViewRFIOrganization = rfiOrganization.View
export const EditRFIOrganization = rfiOrganization.Edit
export const RemoveRestoreRFIOrganization = rfiOrganization.RemoveRestore

export type RFIOrganizationPermission =
  | typeof CreateRFIOrganization
  | typeof ViewRFIOrganization
  | typeof EditRFIOrganization
  | typeof RemoveRestoreRFIOrganization
